import React from 'react';
import cookies from 'js-cookie';
import { Form, Input, Icon, Button } from 'antd';

import requestAPI from '../../helpers/requestAPI';

import './login.scss';

const Login = ({ ...props }) => {
	const { getFieldDecorator, validateFields } = props.form;

	const handleSubmit = (e) => {
		e.preventDefault();
		validateFields((err, value) => {
			if (!err) {
				const params = {
					routeParams: {
						route: 'login'
					},
					method: 'post',
					data: {
						username: value.username, //root
						password: value.password //^&*%3r832ry8sad87
					}
				};

				requestAPI(params)
					.then(function(response) {
						if (response.data.data.auth_token) {
							cookies.set('auth_token', response.data.data.auth_token, { expires: 1 });
							window.location.href = '/'; // most simple case
						}
					})
					.catch(function(error) {
						alert(error);
					});
			}
		});
	};

	return (
		<div className="login__wrapper">
			<Form onSubmit={handleSubmit} className="login-form">
				<Form.Item>
					{getFieldDecorator('username', {
						rules: [ { required: true, message: 'Please input your username!' } ]
					})(<Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" />)}
				</Form.Item>
				<Form.Item>
					{getFieldDecorator('password', {
						rules: [ { required: true, message: 'Please input your Password!' } ]
					})(
						<Input
							prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
							type="password"
							placeholder="Password"
						/>
					)}
				</Form.Item>
				<Button type="primary" htmlType="submit" className="login-form-button">
					Log in
				</Button>
			</Form>
		</div>
	);
};

export default Form.create()(Login);
